export default "__VITE_ASSET__Dp79a0nI__"